import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import MuiTypography from '@material-ui/core/Typography';
import get from 'lodash/get';

const styles = theme => ({
  finePrint: {
    fontSize: '12px',
    color: theme.palette.secondary.dark,
  },
  modalHeader: {
    fontSize: 18,
    margin: '.3rem 0',
    letterSpacing: 1.2,
    fontWeight: 100,
  },
  modalHeader2: {
    fontSize: 10,
    letterSpacing: 1.2,
    fontWeight: 100,
  },
  
});

const typographyColors = ['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary'];

class Typography extends Component {
  render() {
    const {classes, bold = false, children, italic = false, style = {}, theme, upper = false, variant, ...other} = this.props;
    const localStyle = {};
    if (bold) localStyle.fontWeight = 700;
    if (italic) localStyle.fontStyle = 'italic';
    if (upper) localStyle.textTransform = 'uppercase';
    if (other.color && typographyColors.indexOf(other.color) === -1) {
      localStyle.color = get(theme, `palette.${other.color}`);
      delete other.color;
    }
    const className = classes[variant];
    return (
      <MuiTypography className={className} style={{...style, ...localStyle}} variant={className ? undefined : variant} {...other}>
        {children}
      </MuiTypography>
    );
  }
}


Typography.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(Typography);
